<template lang="pug">
  div.revealer(v-in-viewport.once="true")
    div.revealer__motion
      div.revealer__block
        div.block
        h4.revealer__title
          slot(name="text")
</template>


<script>
export default {
  name: 'Revealer'
}
</script>


<style lang="sass" scoped>
  .revealer
    // margin: 1.5rem 0
    &__motion
      display: flex
      justify-content: center
      flex-direction: column
      align-items: flex-end
      position: relative
      width: 100%
      height: 100%
      background-position: center center
      background-repeat: no-repeat
      opacity: 0
    &__block
      position: relative
      // top: 15px
      overflow: hidden
      .block
        position: absolute
        width: 100%
        height: 100%
        opacity: 0
        animation-delay: 0s
        animation-duration: 1s
        transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1)
        background: rgba(230, 233, 236, 0.1)
        background: #070707
    &__title
      font-size: 1.9375rem
      position: relative
      white-space: nowrap
      overflow: hidden
      backface-visibility: hidden
      // margin: 10px
      // padding-right: 20px
      // padding-left: 15px
      opacity: 0
      z-index: -1
      transition: opacity .5s

      > span
        color: #fff
        display: block
        font-weight: 700
        font-size: calc(1.25rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
        &:nth-child(1)
          font-size: calc(1.15rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
          +breakpoint(lg)
            font-size: calc(.6rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))

  // v-in-viewport
  .revealer.in-viewport h4
    transition-delay: 0.6s
  .revealer.in-viewport .revealer__motion, .revealer.in-viewport h4
    opacity: 1
  .revealer.in-viewport .block
    animation-name: run-block

  // Animation
  @keyframes run-block
    0%
      transform: translateX(-100%)
      opacity: 1
    50%
      transform: translateX(0)
      opacity: 1
    100%
      transform: translateX(100%)
      opacity: 1
</style>



// WEBPACK FOOTER //
// src/components/Revealer.vue